<template>
  <div class="cr-spinner">
    <v-progress-circular indeterminate></v-progress-circular>
    {{ props.text }}
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  text: {
    type: String,
    required: true,
  },
})
</script>

<style lang="scss" scoped>
.cr-spinner {
  text-align: center;
  font-size: 20px;
  margin-top: 30px;
}
</style>